$(document).ready(function(){
  function returnRefinedURL (key, url) {
    var urlParts = url.split('?');
    if (urlParts.length === 1 || url.indexOf(key) === -1 ) {
      return url;
    }else {
      var keyValues = urlParts[1].split('&'),
          refinedKeyValues = keyValues.filter(function (keyValuePair) {
            return keyValuePair.indexOf(key) !== 0;
          }).join('&');
    }
    if(refinedKeyValues == ''){
      return urlParts[0]; 
    }else{
      return urlParts[0] + '?' + refinedKeyValues; 
    }        
  }
  
  function loadBundleKit(url, $drawer) {
    $drawer.addClass('loading');
    $.get(url, function(response) {
      if (response) {
        $drawer.find('.drawer-popup-wrapper').html(response);
        $drawer.data('loaded', true);
        $drawer.removeClass('loading');
        syncKitSummary();
      }
    });
  }

  $('.kit-options-drawer').each(function() {
    var $drawer = $(this);
    if ($drawer.data('loaded')) return;

    var url = $drawer.data('collection-url');

    if (url) loadBundleKit(url, $drawer);
  });

  // add collection data on load

  // branding
  const customBranding = (() => {
    const brand1 = [
      'background: green',
      'padding: 5px',
      'color: #fff',
      'font-size: 12px',
      'font-family: "Helvetica Neue", Helvetica, Arial, sans-serif',
      'font-weight: bold',
      'width: 400px',
    ].join(';');
  
    console.log('%c Pack Kit Developer - Savior WebX (shopify.dev.34@gmail.com)', brand1);
  })();
  // branding

  // Remove localstorage when the page is refreshed
  const navEntries = performance.getEntriesByType('navigation'), 
        navigationType = navEntries.length > 0 ? navEntries[0].type : null, 
        isFirstLoad = navigationType === 'navigate',
        redirectFrom = localStorage.getItem('redirect_from');

  if (!isFirstLoad) {
    localStorage.removeItem('redirect_from');
  }
  // Remove localstorage when the page is refreshed
  
  // Change Edit url to normal URL on page load
  var url = new URL(window.location.href);
  if (url.search.includes('b-id:')) {
    var cleanQuery = url.search.split('&')[0];
    const newUrl = url.origin + url.pathname + (cleanQuery ? cleanQuery : '');
    window.history.replaceState({}, '', newUrl);
  }
  // Change Edit url to normal URL on page load

  window.kitOfferText ="Choisissez une couleur [index]";
  let iconClose = '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-close" fill="none" viewBox="0 0 18 17"><path class="icon-close-path" d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z" fill="currentColor"></svg>';

  function adjustHeight(){
    var header = $('.shopify-section-group-header-group .header__wrapper').length > 0 ? 
                 $('.shopify-section-group-header-group .header__wrapper').outerHeight() : 0, 
        announcement_bar = $('.shopify-section--announcement-bar').length > 0 ? 
                 $('.shopify-section--announcement-bar').outerHeight() : 0,
        final_top = header + announcement_bar;
    $('.kit-options-drawer, .kit-product-drawer').css('top',final_top+'px');
  }  

  $(window).on('scroll resize', function(){
    adjustHeight();
  });
  
  // Close Popup
  $('body').on('click', '.close_kit_popup, .overlay-free-product', function(){
    $('.overlay-free-product, .kit-options-drawer, .kit-product-drawer').removeClass('active');
    $('body').removeClass('kit-popup-active unloading overflow-hidden');
  });

  // Update "Choisissez une couleur" text dynamically
  window.updateKitText = function() {
      if ($('.kit-options .nail-selector.OfferKit:not(.kit--added):first').length == 0){
        $('.product__bundle-to-cart').hide();
        $('.product__bundle-to-cart').next('.product__add-to-cart').show();
      } else {
        const activeIndex = $('.kit-options .nail-selector.OfferKit:not(.kit--added):first').data('index'),
              activeText = $('.product__bundle-to-cart').data('button-text').replace('[index]', activeIndex);
        $('.product__bundle-to-cart').next('.product__add-to-cart').hide();
        $('.product__bundle-to-cart').attr('data-button-index', activeIndex).show().html(activeText);
      }
  }

  let kitScope = null;
  function kitSlots() {
    return $(kitScope || document).find('.kit-options .nail-selector.OfferKit');
  }
  function allKitSlots() {
    return $(kitScope || document).find('.kit-options .nail-selector.OfferKit, .kit-options .nail-selector.OptionalKit');
  }
  function ensureOptionalSlot() {
    const optional = allKitSlots().filter('.OptionalKit');
    if (!optional.length || optional.filter(':not(.kit--added)').length) return;
    const source = optional.last();
    const index = Math.max(...allKitSlots().map(function() { return Number($(this).attr('data-index')); }).get()) + 1;
    $('<a href="javascript:void(0);" role="button" class="nail-selector grid__item OptionalKit">')
      .attr('data-index', index)
      .attr('data-product-empty', source.attr('data-product-empty'))
      .html(source.attr('data-product-empty'))
      .appendTo(source.parent());
  }
  function kitSubmitButton() {
    return $(kitScope || document).find('.product__bundle-to-cart').next('.product__add-to-cart').first();
  }
  function syncKitSummary() {
    const slots = kitSlots();
    const count = slots.filter('.kit--added').length;
    const extraCount = allKitSlots().filter('.OptionalKit.kit--added').length;
    $('.kit-selection-summary').each(function() {
      const summary = $(this);
      const total = slots.length;
      summary.find('.kit-selection-count').text(count + ' / ' + total + ' ' + summary.attr('data-selected-label') + (extraCount ? ' · + ' + extraCount + ' ' + summary.attr('data-extra-label') : ''));
      summary.find('progress').attr('max', total || 1).val(count);
      summary.find('.kit-selection-hint').text(count === total ? summary.attr('data-complete-label') : summary.attr('data-remaining-label').replace('{count}', total - count));
      const list = summary.find('.kit-selection-slots').empty();
      allKitSlots().each(function(i) {
        const slot = $(this);
        const title = slot.find('.ps-picker-title').text();
        const optional = slot.hasClass('OptionalKit');
        const discount = slot.find('.kit-badge').text().trim();
        const item = $('<div class="kit-selection-slot">');
        const edit = $('<button type="button" class="kit-selection-edit">').attr('data-slot', i).attr('aria-label', summary.attr('data-edit-label') + ' ' + (i + 1) + ': ' + title);
        edit.toggleClass('is-current', slot.hasClass('active--kit'));
        if (slot.hasClass('kit--added')) {
          edit.append($('<img alt="">').attr('src', slot.find('.blank_images img').attr('src')));
          item.append($('<button type="button" class="kit-selection-remove">').attr('data-slot', i).attr('aria-label', summary.attr('data-remove-label') + ' ' + (i + 1) + ': ' + title).text('×'));
        } else {
          edit.text(optional ? '+' : i + 1);
          if (optional) {
            item.addClass('kit-selection-slot--extra');
            if (discount) edit.append($('<span class="kit-selection-discount">').text(discount));
          }
        }
        item.prepend(edit).append($('<span class="kit-selection-name">').text(title));
        list.append(item);
      });
      const current = list.find('.is-current')[0];
      if (current && summary.closest('.kit-options-drawer').hasClass('active')) {
        const bounds = list[0].getBoundingClientRect();
        const target = current.getBoundingClientRect();
        if (target.right > bounds.right - 8) list[0].scrollLeft += target.right - bounds.right + 8;
        if (target.left < bounds.left + 4) list[0].scrollLeft -= bounds.left - target.left + 4;
      }
      const button = kitSubmitButton();
      summary.find('.kit-selection-submit').prop('disabled', !total || count !== total || !button.length || button.prop('disabled') || button.attr('aria-busy') === 'true');
      summary.closest('.kit-options-drawer').addClass('kit-multiselect');
    });
    const selected = allKitSlots().filter('.kit--added').map(function() { return $(this).attr('data-variant_id'); }).get();
    $('.kit-options-drawer .products-col').each(function() {
      const quantity = selected.filter(id => id === String($(this).data('variant'))).length;
      $(this).toggleClass('kit-colour-selected', quantity > 0).attr('data-selected-count', quantity).attr('aria-pressed', quantity > 0 ? 'true' : 'false');
    });
  }
  $('body').on('click', '.kit-selection-edit', function() {
    allKitSlots().eq(Number($(this).attr('data-slot'))).trigger('click');
  });
  $('body').on('click', '.kit-selection-remove', function() {
    const slot = allKitSlots().eq(Number($(this).attr('data-slot')));
    const optional = slot.hasClass('OptionalKit');
    slot.find('button.ps-sign').trigger('click');
    if (!optional) slot.trigger('click');
  });
  $('body').on('click', '.kit-selection-submit', function() {
    syncKitSummary();
    if ($(this).prop('disabled')) return;
    $('.kit-selection-error').prop('hidden', true);
    kitSubmitButton()[0].click();
    syncKitSummary();
  });
  document.addEventListener('variant:add', function() {
    if (!$('.kit-multiselect.active').length) return;
    $('.overlay-free-product, .kit-options-drawer, .kit-product-drawer').removeClass('active');
    $('body').removeClass('kit-popup-active unloading overflow-hidden');
    syncKitSummary();
  });
  document.addEventListener('cart:error', function(event) {
    $('.kit-multiselect.active .kit-selection-error').text(event.detail.error).prop('hidden', false);
    syncKitSummary();
  });
  $('body').on('keydown', function(event) {
    if (event.key === 'Escape' && $('.kit-multiselect.active').length && !$('.kit-product-drawer.active').length) {
      $('.kit-multiselect.active .close_kit_popup').trigger('click');
      kitSlots().filter('.active--kit')[0]?.focus();
    }
  });

  // bundle button click
  $('body').on('click', '.product__bundle-to-cart', function(e){
    e.preventDefault();
    var index = $(this).attr('data-button-index');
    $('.kit-options .nail-selector.OfferKit[data-index="'+ index +'"]').trigger('click');
  });
  
  // click on kit selector
  $('body').on('click', '.kit-options .nail-selector:not(.choosenOptionalKit)', function(e){
    e.preventDefault();
    kitScope = $(this).closest('.shopify-section')[0];
    window.isOffer = $(this).hasClass('OfferKit') ? true : false;
    window.isOptional = $(this).hasClass('OptionalKit') ? true : false;
    window.emptyHTML = $(this).data('product-empty');
    window.cardIndex = parseInt($(this).data('index'));
    
    $('.kit-options .nail-selector').removeClass('active--kit');
    $(this).addClass('active--kit');
    
    // Open popup
    $('.kit-options-drawer').removeClass('active');
    if ($(this).hasClass('OptionalKit')){
      $('.overlay-free-product, .kit-options-drawer[data-collection-type="optional"]').addClass('active');
    } else {
      $('.overlay-free-product, .kit-options-drawer[data-collection-type="free"]').addClass('active');
    }
    $('body').addClass('kit-popup-active');
    // Open popup

    adjustHeight();
    syncKitSummary();
  });

  // click on choosen discount products
  $('body').on('click', '.kit-options .nail-selector.choosenOptionalKit', function(e){
    e.preventDefault();
    var index = parseInt($(this).data('index')), variantId = $(this).data('variant_id');
    
    if (!$(this).hasClass('active--optional')){
      $(this).addClass('active--optional');
    } else {
      $(this).removeClass('active--optional');
    }
  });
  
  // click on color shade
  $('body').on('click', '.collections-kit .products-col, .kit-product-drawer .kit--drawer-btn', function(e){
    e.preventDefault();
    var product_id = $(this).data('product'), 
        imgSrc = $(this).data('product-src'), 
        title = $(this).data('product-title'),
        variantId = $(this).data('variant');

    var selectedKit = $('.kit-options .nail-selector.active--kit');
    if (!selectedKit.length || $(this).is(':disabled, .products-col--soldout')) return;
    selectedKit.find('button.ps-sign').remove();
    selectedKit.attr('data-product', product_id)
               .attr('data-variant_id', variantId)
               .find('.blank_images').empty().append($('<img>').attr({src: imgSrc, alt: title}))
    selectedKit.find('.ps-picker-title').text(title);
    selectedKit.append('<button type="button" class="ps-sign ps-sign--top-right">'+ iconClose +'</button>');
    
    selectedKit.removeClass('active--kit');
    // NCO — on efface l'etat d'erreur pose par le garde-fou de theme.js
    selectedKit.addClass('kit--added').removeClass('nco-kit-slot--error');
    
    const productData = selectedKit[0]?.outerHTML;
    
    if (window.isOptional) {
      ensureOptionalSlot();
    } else {
      if (kitData.product_form_id){
        selectedKit.parents('.product-info').find('.product-info #'+ kitData.product_form_id).find('[data-items_index="item-'+ window.cardIndex +'"]').val(variantId);
      }
    }

    window.updateKitText();
    if ($('.kit-multiselect.active').length) {
      const next = selectedKit.hasClass('OptionalKit')
        ? allKitSlots().filter('.OptionalKit:not(.kit--added)').first()
        : kitSlots().filter(':not(.kit--added)').first();
      if (next.length) {
        next.addClass('active--kit');
        window.cardIndex = Number(next.data('index'));
        window.emptyHTML = next.attr('data-product-empty');
      }
      $('.kit-product-drawer').removeClass('active');
      $('body').removeClass('unloading overflow-hidden');
      syncKitSummary();
    } else {
      $('.overlay-free-product, .kit-options-drawer, .kit-product-drawer').removeClass('active');
      $('body').removeClass('kit-popup-active unloading overflow-hidden');
    }
  });

  // Remove selected grid / shade
  $('body').on('click','button.ps-sign', function(e){
    e.preventDefault();
    e.stopPropagation();
    const slot = $(this).closest('.nail-selector');
    if (slot.hasClass('OptionalKit')) {
      const wasActive = slot.hasClass('active--kit');
      slot.remove();
      ensureOptionalSlot();
      if (wasActive) allKitSlots().filter('.OptionalKit:not(.kit--added)').first().trigger('click');
    } else {
      slot.attr({'data-product': '', 'data-variant_id': ''}).removeClass('kit--added');
      slot.html(slot.attr('data-product-empty'));
    }
    window.updateKitText();
    syncKitSummary();
  });

  $('body').on('click', '.custom-modal-opener', function(e){
    e.stopPropagation();
    var modal_id = $(this).data('modal-id');
    $('#'+modal_id).addClass('open--modal');
    $('body').addClass("overflow-hidden");
  });

  $('body').on('click', '.modal-popup__close', function(e){
    e.preventDefault();
    $(this).parents('.custom-modal-dialog').removeClass('open--modal');
    $('body').removeClass("overflow-hidden");
  });

  window.refreshBundleProducts = function() {
    fetch(kitData.currentProductURL)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html"),
              destinationKit = document.querySelector('[kitdata-drawer]'), 
              sourceKit = html.querySelector('[kitdata-drawer]');
        if (sourceKit && destinationKit) destinationKit.innerHTML = sourceKit.innerHTML;
      });
  }

  // -------------------------------
  // NEW DRAWER Tabs
  // -------------------------------
  $('body').on('click','.tab-btn', function (e) {
    e.preventDefault();
    const tabId = $(this).attr('id');
    const $target = $('.kit-tab[data-id="' + tabId + '"]');

    if ($target.hasClass('active')) {
      $target.removeClass('active').stop().animate({ height: 0 }, 300);
      $(this).removeClass('active');
      return;
    }

    $('.kit-tab.active').each(function () {
      $(this).removeClass('active').stop().animate({ height: 0 }, 300);
    });

    $('.tab-btn').removeClass('active');
    $target.addClass('active');

    const contentHeight = $target.get(0).scrollHeight;

    $target.stop().animate({
      height: contentHeight
    }, 300);

    $(this).addClass('active');
  }); 

  // Filter
  // $('body').on('click', '[data-filter-btn]', function(e) {
  //   e.preventDefault();

  //   var filter_url = $(this).data('col-url');
  //   var $drawer = $(this).closest('.kit-options-drawer');
    
  //   if (filter_url && $drawer.length) {
  //     loadBundleKit(filter_url, $drawer);
  //     $('.kit-search-input').val('');
  //   }
  // });
  $('body').on('change','[data-filter-btn]',function(e){
    var $drawer = $(this).closest('.kit-options-drawer');
        $col_url = $drawer.data('collection-url'),
        $final_url = $col_url;

        console.log($drawer.find('[data-filter-btn]:checked'), '0000');

    $drawer.find('[data-filter-btn]:checked').each(function(i, ele){  
      var finalVAL = $(ele).data('name')+'='+$(ele).val();  
      console.log(finalVAL, 'finalVAL');
      $final_url = returnRefinedURL(encodeURI($(ele).attr('name')), $final_url);
      $final_url += ($final_url.indexOf('?') >= 0 ? '&' : '?') + finalVAL;
    });
    console.log($final_url, '$final_url');
    loadBundleKit($final_url, $drawer);
  });

  // product info drawer close
  $('body').on('click', '.close_product_popup', function(e){
    e.preventDefault();
    $('.kit-product-drawer').removeClass('active');
    $('.kit-product-drawer-body').html('');
    $('body').removeClass("overflow-hidden");
  });

  // product info drawer open
  $('body').on('click', '[data-kit-product-opener]', function(e){
    e.preventDefault();
    $('.kit-product-drawer').addClass('loading active');
    $('body').addClass("overflow-hidden");
    $.get($(this).data('prod-url'), function(response) {
      if (response) {
        var html = $('<div>').append($.parseHTML(response));
        $('.kit-product-drawer-body').html(html.find('.shopify-section').html());
        $('.kit-product-drawer').removeClass('loading');
      }
    });
  });

  // Search input
  function filterProducts($drawer) {
    const term = $.trim(
      $drawer.find('.kit-search-input').val()
    ).toLowerCase();

    $drawer.find('.kit--product-card').each(function() {
      const text = String(
        $(this).data('search-title') || ''
      ).toLowerCase();

      $(this).toggle(!term || text.includes(term));
    });
  }

  // Search button click
  $('body').on('click', '.kit-search-submit', function(e) {
    e.preventDefault();

    const $drawer = $(this).closest('.kit-options-drawer');
    filterProducts($drawer);
  });

  // Enter key in input
  $('body').on('keydown', '.kit-search-input', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();

      const $drawer = $(this).closest('.kit-options-drawer');
      filterProducts($drawer);
    }
  });

  // Reset button click
  $('body').on('click', '.kit-search-reset', function(e) {
    e.preventDefault();

    const $drawer = $(this).closest('.kit-options-drawer');

    $drawer.find('.kit-search-input').val('');
    $drawer.find('.kit--product-card').show();
  });

  //  infinite scrolling function start
  var screenLoading = false, screenDelay = 200;
  function scrollExecute() {
    var loadingImage, drawer = $('.kit-options-drawer.active'), scrollNode = drawer.find('.lazyLoading'), scrollUrl = drawer.find('.lazyLoading .load_more').attr("href");
    if(!screenLoading && scrollNode.length > 0 && drawer.find('.lazyLoading .load_more').length > 0 && scrollUrl != '') {
      $.ajax({
        type: 'GET',
        url: scrollUrl,
        beforeSend: function() {
          screenLoading = true;
          // loadingImage = scrollNode.clone().empty().append('<div class="preloader"><img src="https://cdn.shopify.com/s/files/1/0577/4570/3089/files/ajax-loader.gif?v=1693821833" /><p>Loading...</p></div>');
          // loadingImage.insertAfter(scrollNode);
          scrollNode.empty();
          // $(loadingImage).addClass('active');
          drawer.find('.lazyLoading .load_more').empty();
        },
        success: function(data) {
          scrollNode.next().remove();
          var filteredData = $(data).find(".custom_scroll_wrap").html();
          var load_btn = $(data).find(".lazyLoading").html();
          drawer.find(".custom_scroll_wrap").append(filteredData);
          drawer.find(".lazyLoading").removeClass('active').empty();
          drawer.find(".lazyLoading").html(load_btn);
          // loadingImage.remove();
          screenLoading = false;
          syncKitSummary();
        },
        dataType: "html"
      });
    }
  }

  let scrollTimeout;
  $('.drawer-popup-wrapper').on('scroll', function () {
    const $listing = $(this);
    if (!$listing.closest('.kit-options-drawer').hasClass('active')) return;

    if ($listing.scrollTop() + $listing.innerHeight() + 50 >= $listing[0].scrollHeight) {
      clearTimeout(scrollTimeout);

      scrollTimeout = setTimeout(function () {
        scrollExecute();
      }, 100);
    }
  });
  //  infinite scrolling function end
});